"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

var _components = require("../../components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  /** setting for bottom padding amount * */
  bottomUnitPadding: _propTypes.number,

  /** Container class name  */
  className: _propTypes.string,

  /** Description text usually a text, but can be a React component  */
  description: _propTypes.node,

  /** An array of key benefits to render as flex items */
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    children: _propTypes.node,
    description: _propTypes.string,
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    title: _propTypes.string
  })),

  /** Container sticky nav id  */
  navId: _propTypes.string,

  /** A function that will be called when the button is clicked */
  onClick: _propTypes.func,

  /** Title text text usually a text, but can be a React component  */
  title: _propTypes.node,

  /** setting for top padding amount * */
  topUnitPadding: _propTypes.number,

  /** Url provided to CtaContainer for links */
  url: _propTypes.string
};
var defaultProps = {
  bottomUnitPadding: 2,
  topUnitPadding: 2
};
var descriptionFont = {
  color: "text",
  fontSize: [3, 4, 4],
  fontWeight: 1,
  letterSpacing: "0.5px",
  lineHeight: [3],
  mt: [1, 1, 3]
};
var keyDescriptionFont = {
  color: "text",
  fontSize: [3],
  fontWeight: 1,
  letterSpacing: "0.5px",
  lineHeight: [2],
  mt: [1]
};
var titleFont = {
  color: "#152935",
  fontSize: [8, 8, 10],
  fontWeight: 2,
  letterSpacing: "-0.5px",
  lineHeight: [2, 2, 1],
  mb: [0]
};
var keyTitleFont = {
  color: "gray-dark",
  fontSize: [3],
  fontWeight: 2,
  lineHeight: [3],
  mb: [0]
};

var KeyBenefitsIntro = function KeyBenefitsIntro(_ref) {
  var bottomUnitPadding = _ref.bottomUnitPadding,
      topUnitPadding = _ref.topUnitPadding,
      className = _ref.className,
      description = _ref.description,
      items = _ref.items,
      onClick = _ref.onClick,
      title = _ref.title,
      navId = _ref.navId,
      url = _ref.url;
  return /*#__PURE__*/_react["default"].createElement(_components.Section, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    flexDirection: ["column", "column", "row"],
    id: navId,
    justifyContent: "center",
    maxWidth: 1440,
    pb: bottomUnitPadding,
    pt: topUnitPadding,
    px: 0,
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "flex-start",
    flexDirection: "column",
    justifyContent: "flex-start",
    mb: [5, 5, 0],
    px: 0,
    width: [1, 1, 1 / 2]
  }, /*#__PURE__*/_react["default"].createElement(_components.PanelText, {
    alignItems: "flex-start",
    description: description,
    descriptionFont: descriptionFont,
    justifyContent: "flex-start",
    title: title,
    titleFont: titleFont
  }), url && /*#__PURE__*/_react["default"].createElement(_components.ButtonsContainer, {
    mt: [3]
  }, /*#__PURE__*/_react["default"].createElement(_components.Cta, {
    darkUi: false,
    glyphRight: /*#__PURE__*/_react["default"].createElement(_components.NavCaretRight, null),
    onClick: onClick,
    url: url,
    version: "link"
  }, "Learn more"))), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    flexDirection: ["column", "column", "row"],
    flexWrap: "wrap",
    justifyContent: "center",
    mb: [5, 5, 0],
    mt: 0,
    px: 0,
    py: 0,
    width: [1, 1, 1 / 2]
  }, (0, _utils.mapIndexed)(function (_ref2, index) {
    var keyTitle = _ref2.title,
        keyDescription = _ref2.description,
        children = _ref2.children;
    return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
      key: index,
      flexDirection: "column",
      mb: 3,
      pr: 0,
      px: [0, 0, 2, 2],
      width: [1, 1, 1, 1 / 2]
    }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
      alignItems: "flex-start",
      px: 0
    }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
      height: 20,
      mr: [2, 2, 3],
      px: 0
    }, /*#__PURE__*/_react["default"].createElement(_components.NavCheckCircle, {
      fill: "blue",
      height: "20px",
      mb: 2,
      width: "20px"
    })), /*#__PURE__*/_react["default"].createElement(_components.PanelText, {
      alignItems: "flex-start",
      justifyContent: "flex-start",
      title: keyTitle,
      titleFont: keyTitleFont
    })), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
      alignItems: "flex-start",
      flexDirection: "column",
      justifyContent: "flex-start",
      pl: ["36px", "36px", "44px"]
    }, /*#__PURE__*/_react["default"].createElement(_components.PanelText, {
      alignItems: "flex-start",
      description: keyDescription,
      descriptionFont: keyDescriptionFont,
      justifyContent: "flex-start"
    }), children));
  }, items))));
};

KeyBenefitsIntro.propTypes = propTypes;
KeyBenefitsIntro.defaultProps = defaultProps;
KeyBenefitsIntro.displayName = "Modules.KeyBenefitsIntro";
var _default = KeyBenefitsIntro;
exports["default"] = _default;